import { render } from "./eduTeamLesson.vue?vue&type=template&id=3f195668&scoped=true"
import script from "./eduTeamLesson.vue?vue&type=script&lang=js"
export * from "./eduTeamLesson.vue?vue&type=script&lang=js"

import "./eduTeamLesson.vue?vue&type=style&index=0&id=3f195668&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f195668"]])

export default __exports__